import { UseDebounceType } from "@website/hooks/debounce/debounce.types";
import { deepCompare } from "@website/utils/deep-compare";
import debounce from "lodash-es/debounce";
import { useEffect, useMemo, useState } from "react";

export const useDebounce: UseDebounceType = (value, timeout) => {
  const [debouncedValue, setDebouncedValue] = useState(value);
  const onChange = useMemo(
    () =>
      debounce(
        (value) =>
          setDebouncedValue((state) =>
            deepCompare(value, state) ? state : value
          ),
        timeout ?? 500
      ),
    [timeout]
  );
  useEffect(() => onChange(value), [onChange, value]);
  return debouncedValue;
};
